import { render } from "./TeamMember.vue?vue&type=template&id=0f15be20"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__